import { Stack } from "@mui/material";
import { ReactNode } from "react";

export const MainWrapper = ({ children }: { children: ReactNode }) => {
  return (
    <Stack
      sx={{
        px: { sm: 8, md: 8, lg: 10, xl: 20 },
        pt: 4,
        pb: 6,
        minHeight: "Calc(100vh - 74px)",
      }}
      gap="40px"
    >
      {children}
    </Stack>
  );
};
